export const mainPathnames = {
  "/": "/",
  "/pricing": {
    de: "/preise",
    fr: "/tarifs",
    es: "/precios",
    pt: "/precos",
    it: "/prezzi",
    nl: "/prijzen",
    ru: "/ceny",
    ar: "/asear",
    hi: "/muly",
    zh: "/jiage",
    ja: "/kakaku",
    ko: "/gagyog",
    id: "/harga",
    tr: "/fiyatlar",
    hu: "/arak",
    pl: "/ceny",
  },
  "/privacy": {
    de: "/datenschutz",
    fr: "/confidentialite",
    es: "/privacidad",
    pt: "/privacidade",
    it: "/privacy",
    nl: "/privacy",
    ru: "/konfidencialnost",
    ar: "/alkhsuysyt",
    hi: "/gopniyata",
    zh: "/yinsi",
    ja: "/puraibashi",
    ko: "/geupim",
    id: "/privasi",
    tr: "/gizlilik",
    hu: "/adatvedelem",
    pl: "/prywatnosc",
  },
  "/terms": {
    de: "/bedingungen",
    fr: "/conditions",
    es: "/terminos",
    pt: "/termos",
    it: "/termini",
    nl: "/voorwaarden",
    ru: "/usloviya",
    ar: "/shurut",
    hi: "/sharton",
    zh: "/tiaokuan",
    ja: "/joken",
    ko: "/jogeon",
    id: "/syarat",
    tr: "/kosullar",
    hu: "/feltetelek",
    pl: "/warunki",
  },
  "/dashboard": {
    de: "/dashboard",
    fr: "/tableau-de-bord",
    es: "/panel",
    pt: "/painel",
    it: "/dashboard",
    nl: "/dashboard",
    ru: "/pribor",
    ar: "/lwht",
    hi: "/dashbord",
    zh: "/kongzhi",
    ja: "/dasshubodo",
    ko: "/deiseubodeu",
    id: "/dashboard",
    tr: "/kontrol",
    hu: "/iranyitopult",
    pl: "/panel",
  },
  "/auth": {
    de: "/anmeldung",
    fr: "/authentification",
    es: "/autenticacion",
    pt: "/autenticacao",
    it: "/autenticazione",
    nl: "/authenticatie",
    ru: "/autentifikaciya",
    ar: "/taqdim",
    hi: "/pramanyikaran",
    zh: "/renzheng",
    ja: "/ninsho",
    ko: "/insaeng",
    id: "/autentikasi",
    tr: "/kimlik",
    hu: "/hitelesites",
    pl: "/uwierzytelnianie",
  },
  "/login": {
    de: "/anmelden",
    fr: "/connexion",
    es: "/iniciar-sesion",
    pt: "/entrar",
    it: "/accedi",
    nl: "/inloggen",
    ru: "/vhod",
    ar: "/dakhul",
    hi: "/login",
    zh: "/denglu",
    ja: "/roguin",
    ko: "/deungnyeog",
    id: "/masuk",
    tr: "/giris",
    hu: "/bejelentkezes",
    pl: "/logowanie",
  },
  "/register": {
    de: "/registrieren",
    fr: "/inscription",
    es: "/registro",
    pt: "/cadastro",
    it: "/registrazione",
    nl: "/registreren",
    ru: "/registraciya",
    ar: "/tasjil",
    hi: "/paddhati",
    zh: "/zhuce",
    ja: "/touroku",
    ko: "/danglog",
    id: "/daftar",
    tr: "/kayit",
    hu: "/regisztracio",
    pl: "/rejestracja",
  },
};
